var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textCover"},[_c('img',{attrs:{"src":this.textObj.story.image}}),_c('div',{staticClass:"gradient",style:({ background: `linear-gradient(to top, ${_vm.convertColor(this.textObj.story.imageHue)}, transparent)` })}),_c('div',{staticClass:"textTitle"},[_vm._v(_vm._s(this.textObj.story.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }